export const taskTypeGroupLabelStyles = {
  position: 'sticky',
  top: '-8px',
  zIndex: 1,
  padding: '8px 16px',
  backgroundColor: ({ palette }) => palette.background.paper,
};

export const taskTypeGroupListStyles = {
  margin: 0,
  padding: 0,
  listStyle: 'none',
};
